module.exports = {
	"swiper-preloader-spin": "findify-layouts--recommendation--swiper__swiper-preloader-spin",
	"swiperPreloaderSpin": "findify-layouts--recommendation--swiper__swiper-preloader-spin"
};